import * as React from 'react';
const BotAvatarIcon = () => (
  <svg width={32} height={32} fill="none">
    <path
      d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
      fill="#E8E8E8"
    />
    <path d="M8.421 6.785v4.252" stroke="#969696" strokeMiterlimit={10} />
    <path
      d="M25.426 13.155c-1.516-3.742-5.175-6.38-9.458-6.38S8.311 9.22 6.694 12.741a6.406 6.406 0 0 0 .607 9.624c1.8 2.904 5 4.834 8.667 4.834 3.668 0 7.124-2.086 8.88-5.184a6.39 6.39 0 0 0 .588-8.852l-.01-.008Z"
      fill="#969696"
    />
    <path
      d="M20.205 11.334h-8.667a5.956 5.956 0 0 0-5.959 5.953 5.956 5.956 0 0 0 5.959 5.954h8.667a5.956 5.956 0 0 0 5.959-5.954 5.956 5.956 0 0 0-5.959-5.953Z"
      fill="#E8E8E8"
    />
    <path
      d="M20.292 18.293a1.452 1.452 0 1 0 0-2.904 1.452 1.452 0 0 0 0 2.904ZM11.635 18.311a1.47 1.47 0 1 0 0-2.94 1.47 1.47 0 0 0 0 2.94Z"
      fill="#969696"
    />
    <path
      d="M14.369 19.616s1.314 1.47 3.226 0"
      stroke="#969696"
      strokeWidth={0.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.123 6.2a.701.701 0 1 1-1.402 0 .701.701 0 0 1 1.402 0Z"
      fill="#969696"
      stroke="#969696"
      strokeWidth={1.397}
    />
    <path d="M14.543 9.306h2.85" stroke="#E8E8E8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default BotAvatarIcon;
